import {LanguageCodes} from '@app/i18n/settings'
import FAQSchema from '..'
import {faqData} from '@app/components/faq-section/data'
import {getHrefFromTag} from '@app/components/sliders/all-tags-slider/helpers'
import {tagPath} from '@app/[lang]/(common-header-footer)/tags/constants'
import {GAMEPLAYER_ROUTE} from '@app/constants/global'
import formatGameName from '@app/components/custom-links/game-link/helper'
import {generateGameUrl} from '@app/[lang]/(common-header-footer)/game/[gameName]/[gameCode]/helper'

type Props = {
  lang: LanguageCodes
}

type TagUrlProps = {
  lang: LanguageCodes
  name: string
  tagId: string
}

type GameUrlProps = {
  lang: LanguageCodes
  gameName: string
  gameCode: string
}

export const generateCanonicalTagUrl = ({lang, name, tagId}: TagUrlProps) => {
  return `https://www.gamezop.com/${lang}/${tagPath}/${getHrefFromTag({
    name,
    tagId,
  })}`
}

export const generateCanonicalGameUrl = ({lang, gameName, gameCode}: GameUrlProps) => {
  return generateGameUrl({
    gameCode,
    gameName: gameName,
    lang,
    host: 'www.gamezop.com',
  })
}

const HomepageFaqSchema = ({lang}: Props) => {
  const faqs = faqData[lang as keyof typeof faqData].faq.faqs
  const inPageText = faqData[lang as keyof typeof faqData].info

  const sanitizedInPageTextData = inPageText
    .filter((item) => item.initalState)
    .map((item) => {
      const text = item.body.text.join(' ')

      const list = `<ol>${item.body.list
        .map((listItem) =>
          listItem.type == 'game'
            ? `<li><a href='${generateCanonicalGameUrl({
                gameCode: listItem.code,
                gameName: listItem.name,
                lang,
              })}'>${listItem.name}</a></li>`
            : `<li><a href='${generateCanonicalTagUrl({
                lang,
                name: listItem.name,
                tagId: listItem.code,
              })}'>${listItem.name}</a></li>`,
        )
        .join('')}</ol>`

      return {
        name: item.title,
        text: item.body.text.length ? text : list,
      }
    })

  const sanitizedFaqs = faqs.map((item) => {
    return {
      name: item.title,
      text: item.body.join(' '),
    }
  })

  const allFaqData = [...sanitizedInPageTextData, ...sanitizedFaqs].filter(Boolean)

  return <FAQSchema faqs={allFaqData} />
}

export default HomepageFaqSchema
